import { Component, EventEmitter, Output } from '@angular/core';
import { IFeedback } from '../gs-share-feedback-modal/feedback.model';

@Component({
  selector: 'gs-share-feedback-button',
  templateUrl: './gs-share-feedback-button.component.html',
  styleUrls: ['./gs-share-feedback-button.component.scss']
})
export class GsShareFeedbackButtonComponent {
  @Output() feedbackClick = new EventEmitter<void>();
  @Output() feedbackSubmitted = new EventEmitter<IFeedback>();

  showFeedbackModal = false;

  onButtonClick(): void {
    this.showFeedbackModal = true;
    this.feedbackClick.emit();
  }

  onFeedbackSubmitted(feedback: IFeedback): void {
    this.feedbackSubmitted.emit(feedback);
    console.log('Feedback submitted:', feedback);
  }
}
